/* eslint-disable @typescript-eslint/no-explicit-any */
import { useLoader, ObjectMap, useThree } from '@react-three/fiber';
import { GLTFLoader } from '@slope/three';
import type { GLTF } from 'three/addons';
import { getDefaultRenderer } from '../utils/index.js';

type Path = string | string[];

export const useGLTF = <T extends Path>(
  input: T,
): T extends any[] ? (GLTF & ObjectMap)[] : GLTF & ObjectMap => {
  const { gl } = useThree();

  return useLoader(GLTFLoader, input, (loader) => {
    if (gl) {
      loader.detectSupport(gl);
    }
  });
};

useGLTF.preload = (input: Path, extensions?: (loader: GLTFLoader) => void) => {
  const defaultRenderer = getDefaultRenderer();
  return useLoader.preload(GLTFLoader, input, (loader) => {
    if (defaultRenderer) loader.detectSupport(defaultRenderer);
    if (extensions) extensions(loader);
  });
};

useGLTF.clear = (input: Path) => {
  return useLoader.clear(GLTFLoader, input);
};
